import { createContext } from "react";
import type { Client, ThreeDSecure } from "braintree-web";

export type BraintreeContextType = {
  braintreeClient: Client | null;
  isLoading: boolean;
  threeDSecure: ThreeDSecure | null;
  regenerateClient: () => void;
};

export const BraintreeContext = createContext<BraintreeContextType | null>(
  null,
);
